import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { BranchListModel } from '../../models/customer/branch-list.model';
@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  customerList(page: number, size: number, filters: any = {}): Observable<any> {
    let url = `${
      environment.apiLocations.customer
    }/Customer?PageRequest.PageIndex=${page - 1}&PageRequest.PageSize=${size}`;

    if (filters.name) {
      url += `&Name=${filters.name}`;
    }

    if (filters.customerCode) {
      url += `&CustomerCode=${filters.customerCode}`;
    }

    if (filters.location) {
      url += `&Location=${filters.location}`;
    }

    if (filters.startCreatedDate) {
      url += `&StartCreatedDateTime=${filters.startCreatedDate}`;
    }

    if (filters.endCreatedDate) {
      url += `&EndCreatedDateTime=${filters.endCreatedDate}`;
    }

    if (filters.email) {
      url += `&Email=${filters.email}`;
    }

    if (filters.totalAnalysis) {
      url += `&TotalAnalysis=${filters.totalAnalysis}`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  allCustomerCodes(): Observable<any> {
    let url = `${environment.apiLocations.customer}/Customer/GetAllCustomerCodes`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getCustomer(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.apiLocations.customer}/Customer/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  createCustomer(organizationData: any): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiLocations.customer}/Customer`,
      organizationData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  editCustomer(id: string, organizationData: any): Observable<any[]> {
    return this.http.put<any[]>(
      `${environment.apiLocations.customer}/Customer/${id}`,
      organizationData,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  deleteCustomer(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiLocations.customer}/Customer/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  allApplications(): Observable<any> {
    let url = `${environment.apiLocations.customer}/Customer/GetAllApplications`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getCustomerBranchesByCustomerCode(
    customerCode: string
  ): Observable<BranchListModel[]> {
    return this.http.get<BranchListModel[]>(
      `${environment.apiLocations.customer}/Customer/GetBranchesByCustomerCode/${customerCode}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  getApplicationsByCustomerCode(code: string): Observable<any> {
    let url = `${environment.apiLocations.customer}/Customer/GetApplicationsByCustomerCode/${code}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
